module.exports = __webpack_public_path__ + "8a37862a5fcc84b5b41315df44fc5c95.png";